/**
 * Announcement bar: mirror slideshow aria-hidden onto inert for slides that contain
 * full-bleed overlay links (focus must not reach off-screen slides).
 */
(function () {
  const BAR = '.announcement-bar';

  /**
   * @param {Element} slideshow
   */
  function syncInert(slideshow) {
    if (!slideshow.closest(BAR)) return;
    slideshow.querySelectorAll('slideshow-slide').forEach((slide) => {
      if (!slide.querySelector('.announcement-bar__link')) return;
      if (slide.getAttribute('aria-hidden') === 'true') {
        slide.setAttribute('inert', '');
      } else {
        slide.removeAttribute('inert');
      }
    });
  }

  /**
   * @param {Element} slideshow
   */
  function bind(slideshow) {
    if (!(slideshow instanceof Element) || slideshow.dataset.announcementInertBound === 'true') {
      return;
    }
    slideshow.dataset.announcementInertBound = 'true';

    const obs = new MutationObserver(() => syncInert(slideshow));
    obs.observe(slideshow, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });

    slideshow.addEventListener('slideshow:select', () => syncInert(slideshow));

    requestAnimationFrame(() => syncInert(slideshow));
  }

  function scan(root = document) {
    root.querySelectorAll(`${BAR} slideshow-component`).forEach((el) => bind(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (target instanceof Element) {
      scan(target);
    }
  });
})();
